module.exports = __webpack_public_path__ + "static/img/Desert.ba45c8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Desert.jpg
// module id = v7f/
// module chunks = 1